export default __webpack_public_path__ + "static/media/s365-inc-logo.83d3ee16.png";